import axios from "axios";

import ApiException from "./ApiException";
import config from "@/app.config.json";
import {Cliente} from "@/services/clientesService";
import {Usuario} from "@/services/usuariosService";
import { ValidacaoResult } from "@/services/Interfaces/IValidacaoResult";

const urlBase = `${config.urlApi}/Vouchers`;  //import.meta.env.VITE_URL_API;

const urls = {
  obter: `${urlBase}`,
  obterPorId: `${urlBase}`,
  adicionar: `${urlBase}`,
  alterar: `${urlBase}`,
  excluir: `${urlBase}`,
}


function getToken(): string {

  const x = localStorage.getItem('user');

  if (x != null) {
    const user = JSON.parse(x);

    if (user && user.accessToken) {
      return `Bearer  ${user.accessToken}`;
    } else {
      return "";
    }
  }
  else
    return "";
}

export const obterPorId = (id: number): Promise<Voucher> => {
  return new Promise((resolve, reject) => {

    const params = {
      id: id
    }

    console.log("obterPorId", id);
    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(`${urls.obterPorId}/${id}`, { params })
      .then((response) => {
        return resolve(response.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter por id")));
  });
};

export const obter = (params?: Filtros | null | any): Promise<Voucher[]> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.obter, { params })
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export async function salvar(model: Voucher): Promise<Voucher> {
  try {
    // Configurar token de autorização
    axios.defaults.headers.common.Authorization = getToken();

    if (model.voucherId && model.voucherId > 0) {
      return (await axios.put(`${urls.alterar}/${model.voucherId}`, model)).data
    } else {
      return (await axios.post(urls.adicionar, model)).data
    }
  } catch (error: any) {
    throw new ApiException(error || "Falha ao salvar ");
  }
}

export async function excluir(id: number): Promise<void> {
  await axios.delete(`${urls.excluir}/${id}`)
}



export interface Filtros {
    voucherId: number | null;
    nome: string | null;
    vendedorId: number | null;
    indicadorId: number | null;
    indicadoId: number | null;
    status: eVoucherStatus | null;
    paginaAtual: number | null;
    tamanhoPagina: number | null;
}

export interface Voucher  {
    voucherId: number;
    vendedorId: number;
    indicadorId: number;
    indicadoId: number;
    valor: number;
    status: eVoucherStatus;
    dataPagamento?: Date;
    dataCartao?: Date;
    dataCadastro?: Date;
    vendedor: Usuario;
    indicador: Cliente;
    indicado: Cliente;
}

export enum eVoucherStatus {
    Pendente = 0,
    Pago = 1,
    Cancelado = 2
}